// extracted by mini-css-extract-plugin
export default {"wrap":"tp-z","logoContainer":"up-z","brandImg":"vp-z","logoImg":"wp-z","logoButton":"xp-z"};